module.exports = __webpack_public_path__ + "img/target-3.a63147a6.jpg";